import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { historySelector } from "redux/slice/historySlice";
import { formatNumber } from "utils/common";
import { Wrapper } from "./styles";
import { getHistorySwap } from "services/history";
import Title from "components/Molecules/Title";
import { formatHash } from "utils/formatAddress";
import { CircularProgress, Dialog } from "@mui/material";
import emptyIcon from 'assets/img/empty.png';
import loadingBoxLottie from "assets/lottie/loading-chart.json";
import Lottie from "react-lottie";

const columns = [
  {
    id: "stt",
    label: "#",
    minWidth: 10,
  },
  {
    id: "amount_from",
    label: "From",
    minWidth: 30,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center' }}>
        <span style={{ fontWeight: 'bold' }}>{formatNumber(row.amount_from)}</span>
        <div style={{ position: 'relative' }}>
          <img
            height="20"
            width="20"
            style={{ borderRadius: '50%' }}
            alt={row.pair.from.name}
            src={row.pair.from.image}
          />
          <img
            height="10"
            width="10"
            alt={row.pair.from.network.name}
            src={row.pair.from.network.image}
            style={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '50%' }}
          />
        </div>
      </div>
    ),
  },
  {
    id: "amount_to",
    label: "To",
    minWidth: 30,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center' }}>
        <span style={{ fontWeight: 'bold' }}>{formatNumber(row.amount_to)}</span>
        <div style={{ position: 'relative' }}>
          <img
            height="20"
            width="20"
            style={{ borderRadius: '50%' }}
            alt={row.pair.to.name}
            src={row.pair.to.image}
          />
          <img
            height="10"
            width="10"
            alt={row.pair.to.network.name}
            src={row.pair.to.network.image}
            style={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '50%' }}
          />
        </div>
      </div>
    ),
  },
  {
    id: "fee",
    label: "Fee",
    minWidth: 30,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center' }}>
        <span style={{ fontWeight: 'bold' }}>{formatNumber(row.fee)}</span>
        <div style={{ position: 'relative' }}>
          <img
            height="20"
            width="20"
            style={{ borderRadius: '50%' }}
            alt={row.pair.from.name}
            src={row.pair.from.image}
          />
          <img
            height="10"
            width="10"
            alt={row.pair.from.network.name}
            src={row.pair.from.network.image}
            style={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '50%' }}
          />
        </div>
      </div>
    ),
  },
  {
    id: "send",
    label: "Send",
    minWidth: 100,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center' }}>
        <a style={{ fontWeight: 'bold', color: '#ffffffba', fontSize: '12px' }} href={row.pair.from.network.explorer_url + '/tx/' + row.hash_from} target="_blank" rel="noreferrer">{formatHash(row.pair.from.network.explorer_url + '/tx/' + row.hash_from)}</a>
      </div>
    ),
  },
  {
    id: "receive",
    label: "Receive",
    minWidth: 100,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center' }}>
        {row.hash_to ? <a style={{ fontWeight: 'bold', color: '#ffffffba', fontSize: '12px' }} href={row.pair.to.network.explorer_url + '/tx/' + row.hash_to} target="_blank" rel="noreferrer">{formatHash(row.pair.to.network.explorer_url + '/tx/' + row.hash_to)}</a> : <CircularProgress size="1.5rem" />}
      </div>
    ),
  },
  {
    id: "created_at",
    label: "Time",
    minWidth: 100,
    renderCell: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: 'center', fontSize: '12px' }}>
        {dayjs(row.created_at).format("MMM DD, YYYY, hh:mm A")}
      </div>
    ),
  },
];

const defaultOption = (data) => {
  return {
    loop: true,
    autoplay: true,
    animationData: data,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
};



export default function HistorySwap({ handleClose, open }) {
  //
  const dispatch = useDispatch();
  const { historySwap, isProcessing } = useSelector(historySelector);
  //
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handleFetch(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    handleFetch(1, +event.target.value);
  };

  const handleFetch = (page, rowsPerPage) => {
    getHistorySwap(dispatch, { page: page, limit: rowsPerPage });
  };
  useEffect(() => {
    handleFetch(1, 10)
  }, [])
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="md"
      PaperProps={{
        style: {
          width: "100%",
          padding: 1,
          backgroundColor: "rgb(67 67 67)",
          color: "white",
          borderRadius: '20px'
        },
      }}
    >
      <Wrapper>
        <div className="container">
          <div style={{ padding: "10px 0" }}>
            <Title title={"History"} subTitle={""} />
          </div>
          {isProcessing && <Lottie options={defaultOption(loadingBoxLottie)} style={{ width: '29.3%' }} />}
          {!isProcessing && historySwap?.rows?.length === 0 &&
            <div style={{ textAlign: 'center' }}>
              <img src={emptyIcon} alt="empty" />
            </div>
          }

          {!isProcessing && historySwap?.rows?.length !== 0 &&
            <div>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          style={{ minWidth: column.minWidth }}
                          sx={{
                            background: "#2acbfe63",
                            color: "white",
                            fontWeight: "bold",
                            textAlign: 'center'
                          }}

                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>

                    {historySwap?.rows?.map((row, idx) => {
                      return (
                        <TableRow hover tabIndex={-1} key={row?.id}>
                          {columns?.map((column) => {
                            const value =
                              column.id === "stt" ? idx + 1 : row[column?.id];
                            return (
                              <TableCell
                                key={column.id}
                                sx={{ color: "#ffffffba" }}
                              >
                                {column.renderCell ? column.renderCell(row) : column.format ? column.format(value) : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                sx={{ color: "white" }}
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={historySwap?.count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          }
        </div>
      </Wrapper>
    </Dialog>);

}
